import { UserRequestOptions } from '@models/user'

export type TeamMemberModel = {
  cache_key: number,
  id: number,
  member_role: string,
  team_id: number,
  team_lead: boolean,
  user_id: number,
}

export interface TeamMemberRequestOptions extends UserRequestOptions {
  include_team_member_user?: boolean,
}

const state = {
  id: null,
  member_role: '',
  team_id: undefined,
  team_lead: false,
  user_id: undefined,
}

export const requiredFields = [
  { key: 'member_role' },
  { key: 'team_id' },
  { key: 'user_id' },
]

export default state
